import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { WebPost } from '../models/models';
import { MultilangModule } from '../trans/multilang.module';
import { MessageCard } from './message-card';
import { PhotoCard } from './photo-card';
import { FsGalleryCard } from './fs-gallery-card';
import { VideoCard } from './video-card';

@Component({
    selector: 'web-post',
    standalone: true,
    imports: [ CommonModule, TranslateModule, MultilangModule,
        MessageCard, PhotoCard, FsGalleryCard, VideoCard ],
    templateUrl: './web-post.html',
    styleUrl: './web-post.scss',
})
export class WebPostComponent {
    @Input({ required: true }) post!: WebPost;

    copied = false;

    get permalink(): string {
        return new URL('post/' + encodeURIComponent(this.post.id), document.baseURI).href;
    }

    copyPermalink(event: MouseEvent) {
        // keep browser defaults for ctrl/shift/meta-click (open in new tab/window)
        if (event.ctrlKey || event.metaKey || event.shiftKey) {
            return;
        }
        event.preventDefault();
        navigator.clipboard.writeText(this.permalink).then(() => {
            this.copied = true;
            setTimeout(() => this.copied = false, 2000);
        });
    }
}
